/**
 * Storage responsive pass (2026-10-27): the price fields are `type="text" inputMode="decimal"`, because an
 * iPhone set to es-UY types the decimal with a comma, which a `type="number"` field drops silently (the
 * value comes back empty and the form says the price is missing).
 *
 * The field keeps what the depósito typed (`sanitizePriceInput` only drops what can never be part of a
 * price); `parsePriceInput` reads it on submit, the way prices are written in Uruguay: a comma is the
 * decimal mark, a point followed by groups of three digits separates thousands ("1.500" is fifteen
 * hundred, "1.500,50" fifteen hundred and a half), and a single point otherwise is the decimal mark
 * ("1500.50"). Anything else is NaN, so the form answers with its own Spanish message instead of
 * sending a guess — a quote 1000× too low reaches the client with no other check on the way.
 */
export function sanitizePriceInput(raw: string): string {
  return raw.replace(/[^\d.,]/g, '');
}

const PLAIN = /^\d+$/;
const THOUSANDS = /^\d{1,3}(\.\d{3})+$/;

export function parsePriceInput(text: string): number {
  if (text.includes(',')) {
    const parts = text.split(',');
    if (parts.length !== 2) return NaN;
    const [whole, decimals] = parts;
    if (!PLAIN.test(decimals) || !(PLAIN.test(whole) || THOUSANDS.test(whole))) return NaN;
    return Number(`${whole.replace(/\./g, '')}.${decimals}`);
  }
  if (THOUSANDS.test(text)) return Number(text.replace(/\./g, ''));
  if (/^\d+(\.\d+)?$/.test(text)) return Number(text);
  return NaN;
}
